import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';


// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');
const GlobalSearch = () => import(/* webpackChunkName: "search" */ '@/views/Dashboard/GlobalSearch.vue');
const Jobs = () => import(/* webpackChunkName: "jobs" */ '@/views/Dashboard/Jobs.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const Settings = () => import(/* webpackChunkName: "pages" */ '@/views/Settings/Settings.vue');
const Keywords = () => import(/* webpackChunkName: "pages" */ '@/views/Settings/Keywords.vue');
const Sachmerkmale = () => import(/* webpackChunkName: "pages" */ '@/views/Settings/Sachmerkmale.vue');
const LLMSettings = () => import(/* webpackChunkName: "pages" */ '@/views/Settings/LLMSettings.vue');
const LLMBenchmark = () => import(/* webpackChunkName: "pages" */ '@/views/Settings/LLMBenchmark.vue');


let authPages = {
  path: '/users',
  component: AuthLayout,
  name: 'Authentication',
  children: [
  
    {
      path: 'login',
      name: 'Login',
      component: Login
    },
    { path: '*', component: NotFound }
  ]
};

const routes = [
 


  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    name: 'Dashboard layout',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'dashboard/:id',
        name: 'DashboardProject',
        component: Dashboard
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings
      },
      {
        path: 'keywords',
        name: 'keywords',
        component: Keywords
      },
      {
        path: 'sachmerkmale',
        name: 'sachmerkmale',
        component: Sachmerkmale
      },
      {
        path: 'llm-settings',
        name: 'LLMSettings',
        component: LLMSettings
      },
      {
        path: 'llm-benchmark',
        name: 'LLMBenchmark',
        component: LLMBenchmark
      },
      {
        path: 'search',
        name: 'GlobalSearch',
        component: GlobalSearch
      },
      {
        path: 'jobs',
        name: 'Jobs',
        component: Jobs
      }
    ]
  },

  authPages,
];

export default routes;
